const ActionButtons = ({ darkMode, activeView, setActiveView }) => {
  // Define a consistent color scheme for all buttons
  const activeColor = darkMode ? "#3B82F6" : "#2563EB";
  const inactiveBorderColor = darkMode ? "#374151" : "#D1D5DB";
  const hoverBackgroundColor = darkMode
    ? "rgba(59, 130, 246, 0.15)"
    : "rgba(37, 99, 235, 0.08)";
  const hoverBorderColor = darkMode ? "#3B82F6" : "#2563EB";

  return (
    <div
      className="flex space-x-4 mb-6 p-4 rounded-lg border bg-white bg-opacity-50"
      style={{
        backgroundColor: darkMode
          ? "rgba(13, 17, 23, 0.5)"
          : "rgba(255, 255, 255, 0.7)",
        borderColor: darkMode ? "#22232B" : "#E5E7EB",
        backdropFilter: "blur(8px)",
        boxShadow: darkMode ? "none" : "0 2px 8px rgba(0, 0, 0, 0.05)",
      }}
    >
      <button
        onClick={() => setActiveView("final")}
        className={`px-5 py-3 rounded-lg font-medium text-sm transition-all duration-300 flex items-center justify-center ${
          activeView === "final" ? "shadow-md" : "border"
        }`}
        style={{
          borderColor:
            activeView === "final" ? activeColor : inactiveBorderColor,
          backgroundColor: activeView === "final" ? activeColor : "transparent",
          color: activeView === "final" ? "#FFFFFF" : activeColor,
          transform: activeView === "final" ? "translateY(-1px)" : "none",
        }}
        onMouseEnter={(e) => {
          if (activeView !== "final") {
            e.target.style.backgroundColor = hoverBackgroundColor;
            e.target.style.borderColor = hoverBorderColor;
            e.target.style.transform = "translateY(-1px)";
          }
        }}
        onMouseLeave={(e) => {
          if (activeView !== "final") {
            e.target.style.backgroundColor = "transparent";
            e.target.style.borderColor = inactiveBorderColor;
            e.target.style.transform = "translateY(0)";
          }
        }}
      >
        <svg
          className="w-4 h-4 mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        Final COPO
      </button>

      <button
        onClick={() => setActiveView("outcomes")}
        className={`px-5 py-3 rounded-lg font-medium text-sm transition-all duration-300 flex items-center justify-center ${
          activeView === "outcomes" ? "shadow-md" : "border"
        }`}
        style={{
          borderColor:
            activeView === "outcomes" ? activeColor : inactiveBorderColor,
          backgroundColor:
            activeView === "outcomes" ? activeColor : "transparent",
          color: activeView === "outcomes" ? "#FFFFFF" : activeColor,
          transform: activeView === "outcomes" ? "translateY(-1px)" : "none",
        }}
        onMouseEnter={(e) => {
          if (activeView !== "outcomes") {
            e.target.style.backgroundColor = hoverBackgroundColor;
            e.target.style.borderColor = hoverBorderColor;
            e.target.style.transform = "translateY(-1px)";
          }
        }}
        onMouseLeave={(e) => {
          if (activeView !== "outcomes") {
            e.target.style.backgroundColor = "transparent";
            e.target.style.borderColor = inactiveBorderColor;
            e.target.style.transform = "translateY(0)";
          }
        }}
      >
        <svg
          className="w-4 h-4 mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
          ></path>
        </svg>
        COs/POs/PSOs
      </button>

      <button
        onClick={() => setActiveView("matrix")}
        className={`px-5 py-3 rounded-lg font-medium text-sm transition-all duration-300 flex items-center justify-center ${
          activeView === "matrix" ? "shadow-md" : "border"
        }`}
        style={{
          borderColor:
            activeView === "matrix" ? activeColor : inactiveBorderColor,
          backgroundColor:
            activeView === "matrix" ? activeColor : "transparent",
          color: activeView === "matrix" ? "#FFFFFF" : activeColor,
          transform: activeView === "matrix" ? "translateY(-1px)" : "none",
        }}
        onMouseEnter={(e) => {
          if (activeView !== "matrix") {
            e.target.style.backgroundColor = hoverBackgroundColor;
            e.target.style.borderColor = hoverBorderColor;
            e.target.style.transform = "translateY(-1px)";
          }
        }}
        onMouseLeave={(e) => {
          if (activeView !== "matrix") {
            e.target.style.backgroundColor = "transparent";
            e.target.style.borderColor = inactiveBorderColor;
            e.target.style.transform = "translateY(0)";
          }
        }}
      >
        <svg
          className="w-4 h-4 mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
          ></path>
        </svg>
        Matrices
      </button>
    </div>
  );
};

export default ActionButtons;
